import Divider from '@cobliteam/ui/components/Divider';
import Typography from '@cobliteam/ui/components/Typography';
import TriggerTemplateAction from './components/TriggerTemplateAction';
import TriggerTemplateParams from './components/TriggerTemplateParams';
import TriggerTemplateRule from './components/TriggerTemplateRule';

interface TriggerTemplateSummaryProps {
  name: string;
  template: string;
}

const TriggerTemplateSummary = ({ name, template }: TriggerTemplateSummaryProps) => {
  return (
    <div className='bg-gray-lightest/50 px-4'>
      <div className='flex py-5'>
        <Typography className='w-1/5' variant='description-title'>
          Evento e Condição
        </Typography>
        <TriggerTemplateRule rule={template} />
      </div>
      <Divider />
      <div className='flex py-5'>
        <Typography className='w-1/5' variant='description-title'>
          Critérios
        </Typography>
        <TriggerTemplateParams />
      </div>
      <Divider />
      <div className='flex py-5'>
        <Typography className='w-1/5' variant='description-title'>
          Ações
        </Typography>
        <TriggerTemplateAction name={name} />
      </div>
    </div>
  );
};

export default TriggerTemplateSummary;
